/**
 * @generated SignedSource<<d519cc9947fd23a63a4bd35dfb6448cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillXlsxImportInput = {
  file: Upload;
  product: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type BillXlsxImportDialog_billXlsxImportMutation$variables = {
  input: BillXlsxImportInput;
};
export type BillXlsxImportDialog_billXlsxImportMutation$data = {
  readonly billXlsxImport: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type BillXlsxImportDialog_billXlsxImportMutation = {
  response: BillXlsxImportDialog_billXlsxImportMutation$data;
  variables: BillXlsxImportDialog_billXlsxImportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Bill",
    "kind": "LinkedField",
    "name": "billXlsxImport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillXlsxImportDialog_billXlsxImportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillXlsxImportDialog_billXlsxImportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3563b82138f4ee274f4082c0b582820",
    "id": null,
    "metadata": {},
    "name": "BillXlsxImportDialog_billXlsxImportMutation",
    "operationKind": "mutation",
    "text": "mutation BillXlsxImportDialog_billXlsxImportMutation(\n  $input: BillXlsxImportInput!\n) {\n  billXlsxImport(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "10f541100e60cca8d7950e828b8c51ac";

export default node;
